<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header" :class="{ 'page-header--scrolled': headerScrolled }">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button fill="clear" color="light" class="header-menu-btn" @click="openMenu">
            <ion-icon :icon="menuOutline" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>Мои подписки</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background events-content" :fullscreen="true" @ionScroll="onContentScroll">
      <ion-refresher slot="fixed" @ionRefresh="load($event)">
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
      <div class="ion-padding">
        <p v-if="loading" class="ion-text-center">Загрузка...</p>
        <div v-else-if="purchases.length === 0" class="empty-block">
          <p>У вас пока нет подписок.</p>
          <router-link to="/showcase" class="empty-link">На главную</router-link>
        </div>
        <ion-list v-else lines="full">
          <ion-item
            v-for="p in purchases"
            :key="p.id"
            button
            @click="$router.push(`/subscriptions/${p.subscriptionId}`)"
          >
            <ion-label>
              <h2>{{ p.subscriptionTitle || 'Подписка' }}</h2>
              <p v-if="p.expiresAt">до {{ formatDate(p.expiresAt) }}</p>
              <p class="purchase-status">
                <span v-if="p.refundedAt" class="status-refunded">Возврат выполнен</span>
                <span v-else-if="p.active" class="status-active">Активна</span>
                <span v-else-if="p.cancelledAt" class="status-cancelled">
                  Отменена<template v-if="p.paidAt">, ожидается возврат</template>
                </span>
                <span v-else-if="!p.paidAt" class="status-pending">Ожидает оплаты</span>
                <span v-else class="status-inactive">Не активна</span>
              </p>
            </ion-label>
          </ion-item>
        </ion-list>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
  menuController
} from '@ionic/vue';
import { menuOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';
import type { ILigaSubscriptionPurchase } from '@/model/liga-subscription-purchase.model';
import subscriptionsService from '@/services/subscriptions.service';
import dayjs from 'dayjs';

export default defineComponent({
  name: 'MySubscriptions',
  components: {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonPage,
    IonRefresher,
    IonRefresherContent,
    IonTitle,
    IonToolbar
  },
  data() {
    return {
      purchases: [] as ILigaSubscriptionPurchase[],
      loading: true,
      headerScrolled: false,
      menuOutline
    };
  },
  ionViewWillEnter() {
    void this.load();
  },
  methods: {
    openMenu() {
      menuController.open('mainMenu');
    },
    onContentScroll(e: CustomEvent) {
      this.headerScrolled = (e.detail?.scrollTop ?? 0) > 16;
    },
    async load(event?: CustomEvent) {
      this.loading = true;
      try {
        this.purchases = await subscriptionsService.getMyPurchases();
        this.purchases.sort((a, b) => (b.purchasedAt || '').localeCompare(a.purchasedAt || ''));
      } catch {
        this.purchases = [];
      }
      this.loading = false;
      (event?.target as { complete?: () => void })?.complete?.();
    },
    formatDate(iso: string) {
      return dayjs(iso).locale('ru').format('D MMMM YYYY');
    }
  }
});
</script>

<style scoped>
.header-menu-btn {
  --color: #fff;
}
.empty-block {
  text-align: center;
  padding: 2rem 1rem;
  color: rgba(255, 255, 255, 0.85);
}
.empty-link {
  color: var(--ion-color-orange);
  font-weight: 600;
  text-decoration: none;
}
ion-item {
  --background: rgba(42, 42, 42, 0.6);
  --color: #fff;
}
.status-active {
  color: #2dd36f;
}
.status-pending {
  color: #ffc409;
}
.status-cancelled,
.status-inactive,
.status-refunded {
  color: rgba(255, 255, 255, 0.6);
}
</style>
